import { Images } from '../../../../@resources/img';
import { uuid } from '../../../../CodesThatsGottaGoSomewhereElse';
import { IndexCard } from '../../paper/IndexCard';
import { TabularImportMappingStep } from '../steps/TabularImportMappingStep';
import { MappingFilter, MappingTarget, TabularImportStrategy } from '../TabularImportModel';
import { createMappingOnlyTabularImportStrategyFunction } from './Shared';

export const IndexCardsTabularImportStrategy: TabularImportStrategy = {
    id: uuid(),
    label: 'Import as Index Cards',
    image: Images.ImportIndexCards,
    steps: [
        TabularImportMappingStep({
            type: IndexCard,
            typeLabel: 'Index Cards',
            preview: [1, 3],
            targets: [
                MappingTarget('Title', 'title', MappingFilter.text(40)),
                MappingTarget('Body', 'content'),
            ]
        }),
    ],
    apply: createMappingOnlyTabularImportStrategyFunction(IndexCard),
};
